import type {Item, AdditionalColumn} from 'shells/table/setup-item-table';

import type {
    GetMarkets_markets_edges_node as Market,
    GetProducts_products_edges_node as Product,
} from 'nutshell-graphql-types';

import {addNotification} from '../../../notifications/index';

import {BASE_COLUMNS} from './consts';

export function generateAdditionalColumns(instanceMarkets: Market[]): AdditionalColumn[] {
    if (!instanceMarkets) {
        return [];
    }

    return [
        ...BASE_COLUMNS,
        ...instanceMarkets.map((market, idx) => ({
            column: {
                id: market.id,
                Header: market.name,
                // @ts-expect-error
                accessor: (row) => {
                    const targetMarket = row.markets.edges.find(
                        // @ts-expect-error
                        (edge) => edge.node.id === market.id
                    );

                    if (!targetMarket || !targetMarket.isAvailable) {
                        return null;
                    }

                    return targetMarket.price && targetMarket.price.formattedWithCents;
                },
                dataType: 'string',
                sortType: sortByMarketPrice,
                width: 100,
                canResize: true,
                shouldTruncate: true,
                rightAlign: true,
            },
            index: idx + 3,
        })),
    ];
}

// Needed to be able to sort by the amount rather than the formatted price
function sortByMarketPrice(rowA: any, rowB: any, id: string) {
    // @ts-expect-error
    const marketA = rowA.original.markets.edges.find((edge) => edge.node.id === id);
    // @ts-expect-error
    const marketB = rowB.original.markets.edges.find((edge) => edge.node.id === id);

    if (!marketA.price && !marketB.price) return 0;
    if (!marketA.price) return 1;
    if (!marketB.price) return -1;

    return marketB.price.amount - marketA.price.amount;
}

export function mapDataToTable(data: Product[]): Item[] {
    return data.map((node: Product) => ({
        // @ts-expect-error
        id: node.id,
        // @ts-expect-error
        name: node.name,
        // @ts-expect-error
        description: node.description,
        // @ts-expect-error
        sku: node.sku,
        // @ts-expect-error
        type: node.type,
        // @ts-expect-error
        term: node.term,
        isDeleteable: true,
        isEditable: true,
        // @ts-expect-error
        markets: node.markets,
        // @ts-expect-error
        lastUsedTime: node.lastUsedTime,
        subtitleIsPill: true,
        categoryName: node.category && node.category.name ? node.category.name : null,
        ...node,
    }));
}

// Convert categoryid to proper value for use in api. We need to pass
// undefined when on all (no query param) tab and null when on uncategorized tab.
export function mapSearchParamToAPIValue(
    categorySearchParam?: string | null
): undefined | null | undefined | string {
    if (categorySearchParam === null) {
        return undefined;
    } else if (categorySearchParam === 'null') {
        return null;
    } else {
        return categorySearchParam;
    }
}

// Convert archived to proper value for use in api.
export function mapParamToArchivedAPIValue(archived?: string | null): boolean | null | undefined {
    switch (archived) {
        case null:
            return undefined;
        case 'null':
            return null;
        case 'true':
            return true;
        case 'false':
            return false;
        default:
            return null;
    }
}

export function notifyUser(product: Product, archived: boolean): void {
    addNotification('Product archived', {
        body: archived
            ? `${product.name} has been archived`
            : `${product.name} has been unarchived`,
        icon: 'archive',
    });
}
